var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({width: '100%', height: '280px'}),attrs:{"id":"histogram"}})}
var staticRenderFns = []

export { render, staticRenderFns }